import React from 'react';
import PropTypes from 'prop-types';

import { Flatpickr } from './Flatpickr';
import { InputContainer } from '../../main-app/components/fields/common/InputContainer';
import { Input } from '../../main-app/components/fields/common/Input';
import icon from '../../main-app/images/icon-datepicker.svg';

const DatePickerField = ({
  name, options, iconPosition, customInput, minDate, maxDate, dateFormat, placeholderText, placeholder, onChange, disableMobile = true, ...rest
}) => (
  <InputContainer>
    <Flatpickr
      options={{
        ...options,
        minDate,
        maxDate,
        disableMobile,
      }}
      name={name}
      customInput={customInput || <Input width="100%" icon={icon} iconPosition={iconPosition} />}
      placeholder={placeholder || placeholderText}
      dateFormat={dateFormat}
      onChange={(val) => onChange(name, rest.mode === 'range' ? val : val[0])}
      {...rest}
    />
  </InputContainer>
);

DatePickerField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.object, // see flatpickr docs for more info https://flatpickr.js.org/options/
  iconPosition: PropTypes.string,
  customInput: PropTypes.node,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  dateFormat: PropTypes.string,
  placeholderText: PropTypes.string,
  placeholder: PropTypes.string,
  disableMobile: PropTypes.bool,
};

DatePickerField.defaultProps = {
  options: {},
  iconPosition: 'left',
  disableMobile: true,
  customInput: undefined,
  minDate: undefined,
  maxDate: undefined,
  dateFormat: undefined,
  placeholderText: undefined,
  placeholder: undefined,
};

export default DatePickerField;
